import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Fügt Klassennamen zusammen und löst Tailwind-Konflikte auf:
 * cn('p-2', 'p-4') ergibt 'p-4', nicht beides.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
